export default 'M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m9 12a12 12 0 1 0 0-24 12 12 0 0 0 0 24';